exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1T3LvFIO_2gMqyOC7uN0E8{text-decoration:line-through}", ""]);
// Exports
exports.locals = {
	"strikethrough": "_1T3LvFIO_2gMqyOC7uN0E8"
};